<app-modal #modal class="create-expense-modal">
  <div class="modal-header">
    <h2 class="modal-title">Create Expense</h2>
  </div>
  <div class="modal-body">
    <form (submit)="onFormSubmit()" [formGroup]="form">
      <input #uploadImageInput (change)="preview(uploadImageInput.files)" accept='image/*,.pdf' style="display: none;"
        type="file">

      <div class="simple-form">
        <div class="form-row" [class.visibility-hidden]="returnTo === 'patient' || isPreloadRedemption">
          <div class="form-label"><label>Patient</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-patient-autocomplete #patientAutoComplete [options]="patientSuggestions" [parentForm]="form"
                [required]="true" controlName="patientName"
                placeholder="Patient Name or Id..."></app-patient-autocomplete>
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="(patient && returnTo === 'patient') || isPreloadRedemption">
          <div class="form-label"><label>Patient</label></div>
          <div class="form-field">
            <div class="form-group">
              <input class="form-control" formControlName="patientName" type="text">
            </div>
          </div>
        </div>
        <div class="form-row" [class.visibility-hidden]="form.get('patientId').value === '' || isPreloadRedemption">
          <div class="form-label"><label>Trial</label></div>
          <div class="form-field">
            <div class="form-group">
              <app-trial-autocomplete #trialAutocomplete [form]="form" controlName="trialId" [autoSelectSingle]="true"
                placeholder="Select a trial..."></app-trial-autocomplete>
            </div>
          </div>
        </div>
        <div class="form-row" *ngIf="isPreloadRedemption">
          <div class="form-label"><label>Trial</label></div>
          <div class="form-field">
            <div class="form-group">
              <input class="form-control" formControlName="trialName" type="text">
            </div>
          </div>
        </div>
        <div [class.visibility-hidden]="!patient || !trial">
          <div class="form-row" [class.visibility-hidden]="isPreloadRedemption" [class.has-non-visits]="hasNonVisits">
            <div class="form-label"><label>{{ showNonVisits ? 'Non-visit' : 'Visit' }}</label></div>
            <div class="form-field">
              <div class="form-group">
                <app-dropdown-input #visitSelect [options]="visitOptions" [parentForm]="form" name="visitId" [filterable]="true" [truncate]="true"
                  [placeholder]="showNonVisits ? 'Select Non-visit...' : 'Select Visit...'"></app-dropdown-input>
                @if (hasNonVisits) {
                  <a class="toggle-non-visits" (click)="toggleNonVisits()">{{ showNonVisits ? 'Show Visits' : 'Show Non-visits' }}</a>
                }
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="isPreloadRedemption">
            <div class="form-label"><label>Visit</label></div>
            <div class="form-field">
              <div class="form-group">
                <div class="fake-field disabled">{{ form.get('visitName').value }}</div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-label"><label>Expense Category</label></div>
            <div class="form-field">
              <div class="form-group">
                <app-dropdown-input #categorySelect [options]="categoryOptions" [parentForm]="form" name="categoryId"
                  placeholder="Select Category..."></app-dropdown-input>
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="trial !== undefined"
            [ngClass]="{'visibility-hidden': selectedCategory === null || selectedCategory.internalType.toLowerCase() !== 'other'}">
            <div class="form-label"></div>
            <div class="form-field">
              <div class="radio-button-container">
                @if (trial.subCategories && trial.subCategories.length > 0) {
                <div *ngFor="let subCategory of trial.subCategories" class="form-group">
                  <label class="radio-button">
                    <input [value]="subCategory.id" formControlName="subCategoryId" type="radio" />
                    <span></span>
                    {{ subCategory.name }}
                  </label>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Value'}">
            <div class="form-label valign-top"><label>Currency</label></div>
            <div class="form-field">
              <div class="form-group">
                <app-autosuggest-dropdown-input #currencySelect [options]="currencyOptions" [parentForm]="form"
                  controlName="currency" placeholder="Select Currency..."></app-autosuggest-dropdown-input>
              </div>
            </div>
          </div>
          <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Value'}">
            <div class="form-label valign-top"><label>Amount</label></div>
            <div class="form-field">
              <div class="form-group amount-container">
                <input class="form-control" formControlName="amount" type="number" (wheel)="disableScrollWheel($event)"
                  (keydown)="numberHelper.decimalFilter($event)">
                <span *ngIf="form.controls.subCategoryId.value === ExpenseSubCategory.CardPreloadRedemption">-</span>
              </div>
            </div>
          </div>
          <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Value'}">
            <div class="form-label valign-top"><label>&nbsp;</label></div>
            <div class="form-field" style="padding-bottom: 20px;">
              <app-button text="FX" type="button" [isBusy]="transformedCurrencyProcessing" width="fill"
                (clicked)="onShowTransformedFxRate()" />
            </div>
          </div>
          <div class="form-row" *ngIf="showFxTransformError && !canTransformRate"
            [ngClass]="{'visibility-hidden': selectedCategory.type != 'Value'}">
            <div class="form-label valign-top"><label>&nbsp;</label></div>
            <div class="form-field">
              <div class="col-12 col-lg-12 quoted-amount-error-message-wrapper">
                <span class="quoted-amount-error-message">
                  The quoted amount, currency and the base currency on connected
                  trial cannot be blank.
                </span>
              </div>
            </div>
          </div>
          <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Value'}">
            <div class="form-label valign-top"><label>Amount Quoted (BC)</label></div>
            <div class="form-field">
              <div class="form-group amount-container">
                <app-input-currency #amountQuotedBCControl [parentForm]="transformedFxRateForm" placeholder="0.00"
                  amountControlName="transformedAmount" currencyControlName="transformedCurrency">
                </app-input-currency>
                <span *ngIf="form.controls.subCategoryId.value === ExpenseSubCategory.CardPreloadRedemption">-</span>
              </div>
            </div>
          </div>
          <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Distance'}">
            <div class="form-label valign-top"><label>Distance Unit</label></div>
            <div class="form-field">
              <div class="form-group">
                <app-dropdown-input #distanceUnitSelect [options]="distanceUnitOptions" [parentForm]="form"
                  name="distanceUnit" placeholder="Select Distance Unit..."></app-dropdown-input>
              </div>
            </div>
          </div>
          <div class="form-row" [ngClass]="{'visibility-hidden': selectedCategory.type != 'Distance'}">
            <div class="form-label valign-top"><label>Distance</label></div>
            <div class="form-field">
              <div class="form-group">
                <input class="form-control" formControlName="distanceAmount" type="number" step="1"
                  (input)="onDistanceAmountInput($event)">
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-label valign-top"><label>Expense Notes</label></div>
            <div class="form-field">
              <div class="form-group">
                <textarea class="form-control" formControlName="notes"></textarea>
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="trial?.imsLegacyTrial">
            <div class="form-label"><label>Claim Form Id</label></div>
            <div class="form-field">
              <div class="form-group">
                <input class="form-control" formControlName="claimFormId" type="text">
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="trial?.imsLegacyTrial">
            <div class="form-label"><label>Claim Form Date</label></div>
            <div class="form-field">
              <div class="form-group form-datepicker">
                <mat-form-field>
                  <input matInput [matDatepicker]="picker" formControlName="claimFormDate">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="trial?.imsLegacyTrial">
            <div class="form-label"><label>Claim Form URL</label></div>
            <div class="form-field">
              <div class="form-group">
                <input class="form-control" formControlName="claimFormUrl" type="text">
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-label"><label>Fully Reconciled</label></div>
            <div class="form-field">
              <div class="form-group">
                <label class="checkbox">
                  <input formControlName="fullyReconciled" type="checkbox">
                  <span></span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="selectedCategory.name !== 'Mileage'">
            <div class="form-label vertical-align-top"><label>Receipt Photos</label></div>
            <div class="form-field expense-add-images">
              <div class="form-group">
                <ul class="images">
                  <li *ngFor="let attachment of attachments; let i = index;">
                    <ng-container *ngIf="attachment.extension !== 'pdf'">
                      <img [src]="attachment.fileUrl" alt="" />
                      <a (click)="onRemoveImage(i)" class="remove">
                        <i aria-hidden="true" class="far fa-times"></i>
                      </a>
                    </ng-container>

                    <ng-container *ngIf="attachment.extension === 'pdf'">
                      <span class="pdf-icon">
                        <i class="far fa-file-pdf"></i>
                      </span>
                      <a (click)="onRemoveImage(i)" class="remove">
                        <i aria-hidden="true" class="far fa-times"></i>
                      </a>
                    </ng-container>
                  </li>
                  <li><a (click)="onAddImage()">+</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-label"></div>
          <div class="form-field">
            <div class="btn-wrap">
              <div class="row">
                <div class="col-6">
                  <a (click)="onCancelEditing()" class="btn btn-secondary">Cancel</a>
                </div>
                <div class="col-6">
                  <button [disabled]="!form.valid || isFormProcessing" class="btn btn-primary" type="submit">
                    <span *ngIf="isFormProcessing">
                      <span aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
                    </span>
                    <span *ngIf="!isFormProcessing">Save</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</app-modal>

<app-modal #removePhotoModal>
  <div class="modal-header">
    <h2 class="modal-title">Delete Photo</h2>
  </div>
  <div class="modal-body">
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <button (click)="removePhotoModal.hide()" class="btn btn-secondary btn-full-span">Cancel</button>
      </div>
      <div class="col-6">
        <button (click)="onConfirmRemoveImage()" class="btn btn-primary btn-full-span">Confirm</button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #preloadConfirmModal>
  <div class="modal-header">
    <h2 class="modal-title">Payment Method Override</h2>
  </div>
  <div class="modal-body">
    <p>Preload expenses can be paid using a Caxton Card, but this patient uses a different default payment method. For this expense the payment method will be changed to Caxton Card. Do you want to proceed?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <button (click)="preloadConfirmModal.hide()" class="btn btn-secondary btn-full-span" type="button">Cancel</button>
      </div>
      <div class="col-6">
        <button (click)="confirmPreloadCardOverride()" class="btn btn-primary btn-full-span" type="button">Proceed</button>
      </div>
    </div>
  </div>
</app-modal>
